export const COLLAPSE_CONTROL_BUTTON_CLASS =
  'bg-gray-15/25 text-gray-90 dark:bg-gray-90/25 dark:text-gray-15 hover:bg-gray-15 dark:hover:bg-gray-90 inline-flex h-[30px] w-5 items-center justify-center rounded-lg transition-colors';

export const COLLAPSE_CONTROL_ICON_CLASS = 'h-4 w-4';
